import React from 'react'
import styled from 'styled-components'
import { useSnapshot } from "valtio";
import { useEffect, useRef } from "react";
import { state } from '../../context/store'

const HorizontalScroller = ({ id, breakpoint = "500px", children, width = "100%", bg = "transparent", justify = "center", mgap = "1rem", gap = "1rem", scroll = "scroll", dDisplay = "repeat(5, 1fr)" }) => {


  const snap = useSnapshot(state);
  const containerRef = useRef(null);

  // Restore scroll position for this instance
  useEffect(() => {
    if (containerRef.current && snap.scrollPositions[id] !== undefined) {
      containerRef.current.scrollLeft = snap.scrollPositions[id];
    }
  }, [id, snap[id]]);

  // console.log(identity)
  // Save scroll position when scrolling
  const handleScroll = () => {
    if (containerRef.current) {
      state.scrollPositions[id] = containerRef.current.scrollLeft;
      // console.log(state.scrollPositions[id])
      // console.log(identity)
      // console.log(containerRef.current.scrollLeft)
    }
  };




  return (
    <Wrap ref={containerRef} $id={id}
      onScroll={handleScroll} $justify={justify} $breakpoint={breakpoint} $scroll={scroll} $width={width} $mgap={mgap} $bg={bg} $gap={gap} $dDisplay={dDisplay}>{children}</Wrap>
  )
}

export default HorizontalScroller

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  ${'' /* width: 100%; */}
  max-width: ${(props) => props.$width};
  background: ${(props) => props.$bg};
  gap: ${(props) => props.$mgap};
  scrollbar-width: none;
  overflow-y: visible;
  overflow-x: ${(props) => props.$scroll};
  justify-content: ${(props) => props.$justify};
  mask-image: linear-gradient( to right, rgba(255, 255, 255, 1) 97%, rgba(0,0,0,0));
  padding: 10px;
  padding-right: 20px; 
  
  @media (width > 1024px) {
    /* background: rgba(240, 128, 128, 0.372); */
    overflow-y: hidden;
    overflow-x: hidden;
    mask-image: none;
    flex-wrap: wrap;
    /* display: grid; */
    padding: 10px;
    padding-right: 10px;
   
    /* grid-template-columns: ${(props) => props.$dDisplay}; */
  }

`